import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, className, ...props }) {
        const isLargeToast = className?.includes('min-w-') || className?.includes('p-6');
        return (
          <Toast key={id} {...props} className={className}>
            <div className="grid gap-1">
              {title && <ToastTitle className={isLargeToast ? 'text-base font-bold' : ''}>{title}</ToastTitle>}
              {description && (
                <ToastDescription className={isLargeToast ? 'text-base' : ''}>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
